console.success = (text) => {
  console.log(`%c${text}`, 'color: #239b56');
};

console.info = (text) => {
  console.log(`%c${text}`, 'color: #344feb');
};
